// From: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
export const numberWithCommas = (value: string | number): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function countDecimalPlaces(num: number): number {
  const [_beforeDecimal, afterDecimal] = num.toString().split(".");
  return afterDecimal?.length ?? 0;
}
